import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdvorLinkComponent } from '@sdvor/shared/ui';
import { IconModule } from '@spartacus/storefront';
import { CityDefinedDialogModule } from '../city-defined-dialog/city-defined-dialog.module';
import { HeaderCitySelectComponent } from './header-city-select.component';

@NgModule({
  declarations: [HeaderCitySelectComponent],
  imports: [NgIf, AsyncPipe, CityDefinedDialogModule, SdvorLinkComponent, IconModule],
  exports: [HeaderCitySelectComponent],
})
export class HeaderCitySelectModule {}
